export default __webpack_public_path__ + "static/desktop_KV02-42e4d96b853967f338323f93486a2b57.mp4";